(function () {
  var dataEl = document.getElementById('rr-data');
  if (!dataEl || window.__runicRenk) return;
  window.__runicRenk = true;
  var D;
  try { D = JSON.parse(dataEl.textContent); } catch (e) { return; }
  var I = {};
  try { var iel = document.getElementById('rr-i18n'); if (iel) I = JSON.parse(iel.textContent) || {}; } catch (e) { I = {}; }
  var U = { areas: 'Kullanım alanları', brands: 'Benzer tonu kullanan markalar', lives: '{name} ile hayat bulanlar', pick: 'Bu rengi seçin', close: 'Kapat', info: 'Renk ayrıntıları', leather: 'Deri', origin: 'Menşei' };
  Object.keys(I.ui || {}).forEach(function (k) { if (I.ui[k]) U[k] = I.ui[k]; });

  function norm(s) { return (s || '').trim().toLowerCase(); }
  var cmap = {};
  Object.keys(D.colors || {}).forEach(function (k) { cmap[norm(k)] = D.colors[k]; });
  Object.keys(I.colors || {}).forEach(function (k) {
    var c = cmap[norm(k)], t = I.colors[k];
    if (!c || !t) return;
    if (t.short) c.short = t.short;
    if (t.desc) c.desc = t.desc;
    if (t.areas && t.areas.length) c.areas = t.areas;
    if (t.origin) c.origin = t.origin;
  });
  var hoverable = window.matchMedia('(hover: hover) and (pointer: fine)');
  var SW = 'li.ecom-product-single__swatch-item[data-value], .gpo-swatches label';
  var INFO_SVG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><circle cx="12" cy="12" r="9"></circle><path d="M12 11v6"></path><path d="M12 7.5v.5"></path></svg>';
  var CLOSE_SVG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"></path></svg>';

  function mk(tag, cls, text) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (text != null) e.textContent = text;
    return e;
  }
  function bigUrl(u) {
    if (!u) return '';
    u = u.replace(/([?&])width=\d+(&|$)/, '$1').replace(/[?&]$/, '');
    return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=1200';
  }
  function swatchName(el) {
    if (el.matches('li')) return el.getAttribute('data-value') || '';
    var i = document.getElementById(el.getAttribute('for'));
    return i ? (i.getAttribute('original-value') || i.value || '') : '';
  }
  function swatchImg(el) {
    var u = '';
    if (el.matches('li')) {
      var s = el.querySelector('span');
      var bg = (s && (s.style.backgroundImage || s.style.background)) || '';
      var p = bg.indexOf('url(');
      if (p > -1) { u = bg.slice(p + 4); u = u.slice(0, u.indexOf(')')).replace(/["']/g, ''); }
    } else {
      var im = el.querySelector('img');
      u = im ? (im.currentSrc || im.src) : '';
    }
    return bigUrl(u);
  }
  function swatchFor(name) {
    var list = document.querySelectorAll('li.ecom-product-single__swatch-item[data-value]');
    for (var i = 0; i < list.length; i++) if (norm(list[i].getAttribute('data-value')) === norm(name)) return list[i];
    return null;
  }

  /* ---------- Tooltip (sadece metin) ---------- */
  var tip = mk('div', 'rr-tip');
  tip.setAttribute('role', 'tooltip');
  tip.innerHTML = '<span class="rr-tip__name"></span><span class="rr-tip__code"></span><span class="rr-tip__arrow"></span>';
  document.body.appendChild(tip);
  var tName = tip.querySelector('.rr-tip__name');
  var tCode = tip.querySelector('.rr-tip__code');
  var tArrow = tip.querySelector('.rr-tip__arrow');
  var hideT = null, cur = null;

  function showTip(el) {
    var name = swatchName(el);
    if (!name) return;
    var c = cmap[norm(name)] || {};
    clearTimeout(hideT);
    cur = el;
    tName.textContent = c.name || name;
    tCode.textContent = '';
    tCode.style.display = 'none';
    var r = el.getBoundingClientRect();
    var w = tip.offsetWidth, h = tip.offsetHeight;
    var left = Math.min(Math.max(r.left + r.width / 2 - w / 2, 8), window.innerWidth - w - 8);
    var below = r.top - h - 10 < 8;
    tip.style.left = left + 'px';
    tip.style.top = (below ? r.bottom + 10 : r.top - h - 10) + 'px';
    tip.classList.toggle('is-below', below);
    tArrow.style.left = (r.left + r.width / 2 - left - 5) + 'px';
    requestAnimationFrame(function () { tip.classList.add('is-on'); });
  }
  function hideTip() {
    clearTimeout(hideT);
    hideT = setTimeout(function () { tip.classList.remove('is-on'); cur = null; }, 60);
  }
  document.addEventListener('mouseover', function (e) {
    if (!hoverable.matches) return;
    var el = e.target.closest && e.target.closest(SW);
    if (el && el !== cur) showTip(el);
  });
  document.addEventListener('mouseout', function (e) {
    var el = e.target.closest && e.target.closest(SW);
    if (el && !(e.relatedTarget && el.contains(e.relatedTarget))) hideTip();
  });
  window.addEventListener('scroll', function () { if (cur) { tip.classList.remove('is-on'); cur = null; } }, { passive: true });

  /* ---------- Bilgi dugmesi (secili renk adinin sagi) ---------- */
  function selectedName() {
    var s = document.querySelector('[data-picker-type="color"] .ecom-product-single__variant-picker--selected-value');
    if (s && s.textContent.trim()) return s.textContent.trim();
    var a = document.querySelector('li.ecom-product-single__swatch-item.ecom-box-active[data-value]');
    return a ? a.getAttribute('data-value') : '';
  }
  function ensureBtn() {
    var labs = document.querySelectorAll('[data-picker-type="color"] .ecom-product-single__picker-main-label');
    Array.prototype.forEach.call(labs, function (lab) {
      var b = lab.querySelector('.rr-info');
      if (!b) {
        b = mk('button', 'rr-info');
        b.type = 'button';
        b.setAttribute('aria-label', U.info);
        b.innerHTML = INFO_SVG;
      }
      var sel = lab.querySelector('.ecom-product-single__variant-picker--selected-value');
      if (sel) {
        if (sel.nextElementSibling !== b) sel.insertAdjacentElement('afterend', b);
      } else if (b.parentNode !== lab || lab.lastElementChild !== b) {
        lab.appendChild(b);
      }
    });
  }
  ensureBtn();
  var pend = false;
  new MutationObserver(function () {
    if (pend) return;
    pend = true;
    requestAnimationFrame(function () { pend = false; ensureBtn(); });
  }).observe(document.body, { childList: true, subtree: true });

  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.rr-info');
    if (!b) return;
    e.preventDefault();
    e.stopPropagation();
    openModal(selectedName());
  }, true);

  /* ---------- Renk karti ---------- */
  var modal = mk('div');
  modal.id = 'rr-modal';
  modal.hidden = true;
  modal.innerHTML = '<div class="rr-backdrop" data-rr-close></div><div class="rr-dialog" role="dialog" aria-modal="true"><div class="rr-handle"><span></span></div><div class="rr-head"></div><div class="rr-scroll"><div class="rr-hero"></div><div class="rr-content"></div></div><div class="rr-foot"><button type="button" class="rr-pick"></button></div></div>';
  document.body.appendChild(modal);
  modal.querySelector('.rr-pick').textContent = U.pick;
  var head = modal.querySelector('.rr-head');
  var hero = modal.querySelector('.rr-hero');
  var content = modal.querySelector('.rr-content');
  var dialog = modal.querySelector('.rr-dialog');
  var curName = '', lastFocus = null, closeT = null;

  function variantShots(name) {
    var out = [], seen = {};
    (D.variants || []).forEach(function (v) {
      if (out.length >= 2 || !v.img || seen[v.img]) return;
      if ((v.o || []).some(function (x) { return norm(x) === norm(name); })) { seen[v.img] = 1; out.push({ src: v.img, alt: D.title || '' }); }
    });
    return out;
  }
  function chipSection(title, items, cls) {
    var s = mk('section');
    s.appendChild(mk('h3', 'rr-h', title));
    var wrap = mk('div', 'rr-chips');
    items.forEach(function (a) { wrap.appendChild(mk('span', 'rr-chip' + (cls ? ' ' + cls : ''), a)); });
    s.appendChild(wrap);
    return s;
  }

  function fillModal(name) {
    var c = cmap[norm(name)] || {};
    var title = c.name || name;
    curName = name;
    dialog.setAttribute('aria-label', title);

    head.innerHTML = '';
    head.appendChild(mk('h2', 'rr-title', title));
    if (c.origin) head.appendChild(mk('span', 'rr-badge', c.origin));
    var x = mk('button', 'rr-close');
    x.type = 'button';
    x.setAttribute('aria-label', U.close);
    x.setAttribute('data-rr-close', '');
    x.innerHTML = CLOSE_SVG;
    head.appendChild(x);

    var sw = swatchFor(name);
    var img = c.img || (sw ? swatchImg(sw) : '');
    hero.style.backgroundImage = img ? 'url("' + img + '")' : '';

    content.innerHTML = '';
    if (c.desc) content.appendChild(mk('p', 'rr-desc', c.desc));

    var specs = [['Pantone', c.pantone], ['RAL', c.ral ? c.ral.replace(/^RAL\s*/i, '') : ''], ['HEX', c.hex ? c.hex.toUpperCase() : ''], [U.leather, c.leather], [U.origin, c.origin]].filter(function (p) { return p[1]; });
    if (specs.length) {
      var g = mk('div', 'rr-specs');
      g.style.gridTemplateColumns = 'repeat(' + specs.length + ', minmax(0, 1fr))';
      specs.forEach(function (p) {
        var cell = mk('div', 'rr-spec');
        cell.appendChild(mk('span', '', p[0]));
        var val = mk('span');
        if (p[0] === 'HEX') { var dot = mk('i', 'rr-dot'); dot.style.background = c.hex; val.appendChild(dot); }
        val.appendChild(document.createTextNode(p[1]));
        cell.appendChild(val);
        g.appendChild(cell);
      });
      content.appendChild(g);
    }

    if (c.areas && c.areas.length) content.appendChild(chipSection(U.areas, c.areas));
    var brands = (c.brands && c.brands.length) ? c.brands : (c.family ? [c.family] : []);
    if (brands.length) content.appendChild(chipSection(U.brands, brands, 'rr-chip--brand'));

    var shots = (c.shots && c.shots.length) ? c.shots : variantShots(name);
    if (shots.length) {
      var s2 = mk('section');
      s2.appendChild(mk('h3', 'rr-h', U.lives.replace('{name}', title)));
      var grid = mk('div', 'rr-shots');
      shots.slice(0, 2).forEach(function (sh) {
        var f = mk('figure', 'rr-shot');
        var box = mk('div');
        box.style.backgroundImage = 'url("' + sh.src + '")';
        box.setAttribute('role', 'img');
        box.setAttribute('aria-label', sh.alt || title);
        f.appendChild(box);
        if (sh.caption) f.appendChild(mk('figcaption', '', sh.caption));
        grid.appendChild(f);
      });
      s2.appendChild(grid);
      content.appendChild(s2);
    }
    modal.querySelector('.rr-foot').style.display = sw ? '' : 'none';
    modal.querySelector('.rr-scroll').scrollTop = 0;
  }

  function openModal(name) {
    if (!name) return;
    clearTimeout(closeT);
    tip.classList.remove('is-on');
    fillModal(name);
    lastFocus = document.activeElement;
    modal.hidden = false;
    document.documentElement.classList.add('rr-lock');
    requestAnimationFrame(function () {
      modal.classList.add('is-open');
      var c = modal.querySelector('.rr-close');
      if (c) c.focus({ preventScroll: true });
    });
  }
  function closeModal() {
    if (modal.hidden) return;
    modal.classList.remove('is-open');
    document.documentElement.classList.remove('rr-lock');
    closeT = setTimeout(function () { modal.hidden = true; }, 280);
    if (lastFocus && lastFocus.focus) { try { lastFocus.focus({ preventScroll: true }); } catch (e) {} }
  }
  modal.addEventListener('click', function (e) {
    if (e.target.closest('[data-rr-close]')) { closeModal(); return; }
    if (e.target.closest('.rr-pick')) {
      var sw = swatchFor(curName);
      closeModal();
      if (sw) sw.click();
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !modal.hidden) { e.preventDefault(); closeModal(); }
  });

  window.RunicRenk = { open: openModal, close: closeModal };
})();